export default __webpack_public_path__ + "images/CY.8e9f7b1.png";